import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    dashBoardIcons: {
        fontSize: '24px'
    },
    filterButton: {
        '&:hover': {
            backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
        }
    },
    queryTable: {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark.light + 15 : theme.palette.primary.light,
        padding: '16px'
    },
    grid: {
        width: '100%',
        height: '100vh',
        maxHeight: '600px',
        margin: '10px',
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            borderRadius: '12px'
        },
        [theme.breakpoints.up('sm')]: {
            width: '42%',
            justifyContent: 'center'
        },
        [theme.breakpoints.up('md')]: {
            width: 'calc(25% - 20px)',
            justifyContent: 'center'
        }
    },
    inputFieldButton: {
        [theme.breakpoints.up('md')]: {
            display: 'flex'
        }
    },
    adjustMargin: {
        marginTop: '24px',
        [theme.breakpoints.up('md')]: {
            marginTop: '0'
        }
    },
    sideBarSubheading: {
        fontWeight: 500,
        color: theme.palette.grey[700]
    },
    contactDetails: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        fontWright: 500,
        color: theme.palette.grey[700]
    },
    searchGrid: {
        boxShadow: '0px 15px 29px 0px #090F250A'
    },
    shadowCard: {
        boxShadow: '1px 3px 12px 0px #00000014'
    },
    tableHeader: {
        backgroundColor: theme.palette.background.paper,
        position: 'sticky',
        top: 0,
        zIndex: 999
    },
    primaryBackground: {
        backgroundColor: `${theme.palette.primary.light} !important`
    },
    stickyTableRow: {
        backgroundColor: theme.palette.background.paper,
        position: 'sticky',
        left: 0,
        zIndex: 99
    },
    tableCell: {
        padding: '16px'
    },
    cardTitle: {
        fontSize: '14px',
        color: theme.palette.grey.primary,
        fontWeight: 400
    },
    toolTipStyleSuccess: {
        color: theme.palette.success.dark,
        backgroundColor: theme.palette.success.light,
        border: `2px solid ${theme.palette.success.dark}`,
        borderRadius: '7px'
    },
    toolTipArrowSuccess: {
        color: theme.palette.success.dark
    },
    toolTipStyleWarning: {
        color: theme.palette.orange.main,
        backgroundColor: theme.palette.orange.light,
        border: `2px solid ${theme.palette.orange.main}`,
        borderRadius: '7px'
    },
    toolTipArrowWarning: {
        color: theme.palette.orange.main
    },
    kycHeading: {
        fontWeight: 400,
        color: theme.palette.grey.primary,
        lineHeight: '0.6em'
    }
}));

export default useStyles;
